export default __webpack_public_path__ + "static/media/inter-regular.10194357.woff";